import { call, put } from 'redux-saga/effects';
import * as actions from '../actions/adminActs';
import { post } from '../../utils/api';
import { errorModalOpen } from '../../utils/functions';

export function* getActs({ payload }) {
  try {
    const response = yield call(post, '/admin/document/find', payload);
    yield put(actions.getActsSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getActsFail());
  }
}

export function* signActs({ payload }) {
  try {
    const response = yield call(post, '/integration/doc_sign/', payload);
    yield put(actions.signActsSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.signActsFail());
  }
}
